export const checkPw = (pw: string): string => {
  if (pw.length === 0) {
    return '필수항목';
  }

  const pattern = /^(([0-9]+)|([a-z]+)|([A-Z]+)|([!@#$%^&*]+))+$/;
  if (pw.length < 8 || pw.length > 15 || !pattern.test(pw)) {
    return '8~15자의 영문,숫자,특수문자(!@#$%^&*)입력';
  }

  let pwCnt = 0;
  if (/[0-9]/.test(pw)) pwCnt += 1;
  if (/[a-z]/.test(pw)) pwCnt += 1;
  if (/[A-Z]/.test(pw)) pwCnt += 1;
  if (/[!@#$%^&*]/.test(pw)) pwCnt += 1;
  if (pwCnt < 3) {
    return '8~15자의 영문,숫자,특수문자(!@#$%^&*)입력';
  }
  return '';
};

export const checkPwRe = (pw: string, pwRe: string): string => {
  if (pwRe.length === 0) {
    return '필수항목';
  }

  if (pw !== pwRe) {
    return '비밀번호 불일치';
  }

  return '';
};
